import { useState, useEffect } from 'react';
import { listenToShowCards, listenToShowState } from '../utils/firebase/whatnotShow';

/**
 * Read-only show listener for the OBS viewer overlay.
 * Uses hostUid from the URL instead of the logged-in user,
 * so it works in OBS browser sources with no authenticated session.
 */
export function useShowViewer(hostUid, showId) {
    const [cards, setCards]         = useState([]);
    const [show, setShow]           = useState({ currentCardIndex: 0 });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!hostUid || !showId) return;

        setIsLoading(true);
        let cardsReady = false;
        let showReady  = false;

        const tryFinish = () => {
            if (cardsReady && showReady) setIsLoading(false);
        };

        const unsubCards = listenToShowCards(hostUid, showId, (c) => {
            setCards(c);
            cardsReady = true;
            tryFinish();
        });

        const unsubShow = listenToShowState(hostUid, showId, (s) => {
            setShow(s);
            showReady = true;
            tryFinish();
        });

        return () => {
            unsubCards();
            unsubShow();
        };
    }, [hostUid, showId]);

    return { show, cards, isLoading };
}
